import { render, staticRenderFns } from "./SelectCenterAdmin.vue?vue&type=template&id=6dc000b1&scoped=true&"
import script from "./SelectCenterAdmin.vue?vue&type=script&lang=js&"
export * from "./SelectCenterAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SelectCenterAdmin.vue?vue&type=style&index=0&id=6dc000b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc000b1",
  null
  
)

export default component.exports